import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES = defineFcm('signature_growth_psf_fb_share_headlines')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				isEnabled: { type: 'boolean' },
				experimentName: { type: 'string' },
				variants: {
					type: 'record',
					keys: ['fake_control', 'variant1', 'variant2', 'variant3', 'variant4'] as const,
					optionalValues: true,
					shape: { type: 'object', shape: { title: { type: 'string' }, description: { type: 'string' } } },
				},
			},
		}),
	)
	.withDefault({
		isEnabled: false,
		experimentName: '',
		variants: {
			fake_control: { title: '', description: '' },
			variant1: { title: '', description: '' },
			variant2: { title: '', description: '' },
			variant3: { title: '', description: '' },
			variant4: { title: '', description: '' },
		},
	})
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'PSF',
		description: 'Select a different title and description when sharing via Facebook in the PSF.',
		deprecated: 'FCM no longer in use — safe to delete after 2026-05-14',
		import: false,
		template: {
			isEnabled: false,
			experimentName: '',
			variants: {
				fake_control: {
					title: '',
					description: '',
				},
				variant1: {
					title: '',
					description: '',
				},
				variant2: {
					title: '',
					description: '',
				},
				variant3: {
					title: '',
					description: '',
				},
				variant4: {
					title: '',
					description: '',
				},
			},
		},
	});
